export function pct(value) {
  if (value === null || value === undefined) return "-";
  return `${Math.round(value * 100)}%`;
}

export function money(value) {
  if (value === null || value === undefined) return "-";
  return `₹${Number(Math.round(value)).toLocaleString("en-IN")}`;
}

// Abbreviated INR for KPI values and chart axes (₹12.4 L, ₹3.2 Cr).
export function moneyCompact(value) {
  if (value === null || value === undefined) return "-";
  const n = Number(value);
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(1)} Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(1)} L`;
  return `₹${Number(Math.round(n)).toLocaleString("en-IN")}`;
}

export function num(value) {
  if (value === null || value === undefined) return "-";
  return Number(value).toLocaleString();
}

export function changeArrow(change) {
  if (change === null || change === undefined) return { symbol: "-", label: "no change" };
  if (change > 0.001) return { symbol: "↑", label: `${Math.round(change * 100)}% vs last period` };
  if (change < -0.001) return { symbol: "↓", label: `${Math.round(Math.abs(change) * 100)}% vs last period` };
  return { symbol: "→", label: "no change vs last period" };
}

export function shortDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export function daysUntil(iso) {
  if (!iso) return null;
  return Math.round((new Date(iso) - new Date()) / 86400000);
}

export function relativeLastActive(iso) {
  if (!iso) return "Never";
  const days = Math.round((new Date() - new Date(iso)) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days} days ago`;
  return shortDate(iso);
}

export const CATEGORY_LABELS = {
  research: "Research",
  drafting: "Drafting",
  review: "Review",
  general_assistant: "General assistant",
};

export const TRACKING_LABELS = {
  extension: "Extension",
  vendor_report: "Vendor report",
  both: "Both",
};

// Metric definitions reused in every tooltip (plain words, section 5).
export const METRIC_DEFS = {
  active_user: "A member with at least 1 feature used or 5 active minutes in that tool during the period.",
  seat_utilisation: "Active users holding a seat, divided by seats bought.",
  idle_seat: "A seat whose holder has had no activity for 30 days.",
  adoption: "Members using any AI tool, divided by team members.",
  feature_use_count: "Number of feature-used events for that feature in the period.",
  feature_reach: "Distinct members who used the feature, divided by active users of that tool.",
  depth: "Average distinct features used per active user.",
  stickiness: "Average weekly active users divided by monthly active users.",
  active_minutes: "Minutes with the tab focused plus a click, key press or scroll.",
  cost_per_active_user: "Monthly cost divided by monthly active users.",
  usage_level: "Regular: active in 3+ of the last 4 weeks. Occasional: 1-2 weeks. Not yet: 0.",
};

export const PURPOSE_LINE = "This data is for tool and training decisions only.";
